import React from 'react'
import ReactTable from 'react-table';
import { getFormattedTiming, frequencyItem } from '../../../common/utils';
import _ from 'lodash'

class TaxSaving extends React.Component {

    taxSavingReceipt = (item) => {
        if (item === false) {
            item = <span style={{ color: "#ff0000" }}>No</span>;
        }
        else if (item === true) {
            item = <span style={{ color: "#008000" }}>Yes</span>;
        }
        return item;
    }

    bindSavingDataTable = (items) => {
        const taxSavingArr = [];
        if (items.taxSaving.length !== 0) {
            for (var i = 0; i < items.taxSaving.length; i++) {
                const collection = {
                    taxSavingId: items.taxSaving[i].TaxSavingId,
                    employeeId: items.taxSaving[i].EmployeeId,
                    fullName: items.taxSaving[i].FullName,
                    taxSavingTypeName: items.taxSaving[i].TaxSavingTypeName,
                    recurringFrequency: frequencyItem(items.taxSaving[i].RecurringFrequency),
                    savingDate: getFormattedTiming(items.taxSaving[i].SavingDate),
                    accountNumber: items.taxSaving[i].AccountNumber,
                    amount: items.taxSaving[i].Amount + ".00",
                    totalAmount: items.taxSaving[i].TotalAmount + ".00",
                    remarks: items.taxSaving[i].Remarks,
                    receiptSubmitted: this.taxSavingReceipt(items.taxSaving[i].ReceiptSubmitted)
                }
                taxSavingArr.push(collection)
            }
        }
        if (taxSavingArr.length === 0) {
            if (this.props.dashboardData.userRole !== 'Admin') {
                taxSavingArr.push({
                    taxSavingTypeName: "No Row Found"
                })
            }
            else {
                taxSavingArr.push({
                    fullName: "No Row Found"
                })
            }
        }

        return taxSavingArr;
    }

    selectTaxSavingRow = (taxSavingRecordId, employeeId) => {
        this.props.selectTaxSavingRowData(taxSavingRecordId, employeeId)
    }


    render() {
        const savingDataTable = _.orderBy(this.props.taxSavingRecords, ['FullName', 'TaxCategoryCode', 'SavingDate']);

        const columns = [
            {
                id: 'TaxSavingRecordId',
                accessor: 'TaxSavingRecordId',
                show: false
            },
            {
                Header: "Employee",
                accessor: "FullName",
                width: 200,
                headerStyle: { textAlign: 'left' },
                style: { textAlign: 'left', paddingRight: 10 },
                className: "header-class table-border",
                show: true
            },
            {
                Header: "Saving Type",
                accessor: "TaxSavingTypeName",
                width: 200,
                className: "header-class table-border",

            },
            {
                Header: "Type",
                accessor: "TaxCategoryCode",
                width: 100,
                className: "header-class table-border",

            },
            {
                Header: "Frequency",
                accessor: "RecurringFrequencyName",
                width: 120,
                className: "header-class table-border",
            },
            {
                Header: "Date",
                accessor: "SavingDate",
                width: 120,
                className: "header-class table-border",
            },
            {
                Header: "Policy/Account No./Description",
                accessor: "AccountNumber",
                width: 470,
                className: "header-class table-border",
            },
            {
                Header: "Amount",
                accessor: "Amount",
                width: 100,
                headerStyle: { textAlign: 'center' },
                style: { textAlign: 'right', paddingRight: 10 },
                className: "header-class table-border",
            },
            {
                Header: "Receipt",
                accessor: "ItemCount",
                width: 80,
                headerStyle: { textAlign: 'center' },
                style: { textAlign: 'right', paddingRight: 10 },
                className: "header-class table-border",
            },
            {
                Header: "Remarks",
                accessor: "Remarks",
                className: "header-class table-border",
            }
        ]
        if (this.props.dashboardData.userRole !== 'Admin') {
            columns.shift()
        }
        return (
            <>
                <div className="row">
                    <div className="container-fluid" style={{ marginBottom: 20 }}>
                        <ReactTable className="-highlight IRTable"
                            columns={columns}
                            data={savingDataTable}
                            showPagination={false}
                            pageSize={savingDataTable.length}
                            // sortable={false}
                            multiSort={true}
                            getTrProps={(state, rowInfo, column, instance) => {
                                return {
                                    onClick: () => {
                                        this.selectTaxSavingRow(rowInfo.original.TaxSavingRecordId, rowInfo.original.EmployeeId)
                                    },
                                    style: {

                                        backgroundColor: (this.props.taxSavingRecordId === (rowInfo && rowInfo.original.TaxSavingRecordId)) ? this.props.rowBackgroundColor : "",
                                        fontSize: 'small',
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </>
        )
    }
}
export default TaxSaving